class LicenceStore {
  private static instance: LicenceStore | undefined;

  public _data: { [key: string]: any } = {
    licenceId: null,
    formData: {},
    firearmToLinkIds: [],
    firearmLinkToBeRemovedIds: [],
    firearmCurrentLink: [],
    firearmRemovedObjects: [],
    firearmCurrentLinkInitialized: false,
    safeStorages: [],
    licenceAttachmentsData: [],
    licenceAttachmentsToDeleteIds: [],
    photoFile: null,
    image: null,
    selectedPrice: null,

    firearmRemovedIds: [],
  };

  constructor() {
    if (!LicenceStore.instance) {
      LicenceStore.instance = this;
    }

    (window as any).LicenceStore = this._data;

    // eslint-disable-next-line no-constructor-return
    return LicenceStore.instance;
  }

  setValue(key: string, value: any) {
    this._data[key] = value;
  }

  getValue(key: string) {
    return this._data?.[key] ? this._data[key] : null;
  }

  clearValue(key: string) {
    this._data[key] = [];
  }

  getFormData(uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      const isEmpty = Object.keys(this._data.formData).length === 0;
      const result = isEmpty ? null : this._data.formData;
      return result;
    }
    return null;
  }

  setFormData(value: any, uniqueId: string) {
    this._data.formData = value;
    this._data.licenceId = uniqueId;
  }

  setFormSafeStorages(value: any, uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      this._data.safeStorages = value;
    }
  }

  getFormSafeStorages(uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      return this._data.safeStorages;
    }
    return [];
  }

  setFormLicenceAttachmentsData(value: any) {
    this._data.licenceAttachmentsData = value;
  }

  getFormLicenceAttachmentsData(uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      return this._data.licenceAttachmentsData;
    }
    return [];
  }

  setFormLicenceAttachmentsToDeleteIds(value: any) {
    this._data.licenceAttachmentsToDeleteIds = value;
  }

  getFormLicenceAttachmentsToDeleteIds(uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      return this._data.licenceAttachmentsToDeleteIds;
    }
    return [];
  }

  setFormPhotoFile(value: any, uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      this._data.photoFile = value;
    }
  }

  getFormPhotoFile(uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      return this._data.photoFile;
    }
    return [];
  }

  setFormImage(value: any, uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      this._data.image = value;
    }
  }

  getFormImage(uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      return this._data.image;
    }
    return [];
  }

  setFormFirearmCurrentLink(value: any, uniqueId: string) {
    if (
      this._data.licenceId &&
      this._data.licenceId !== uniqueId &&
      this._data.firearmCurrentLink
    ) {
      this._data.firearmCurrentLink = [];
      this._data.firearmToLinkUniqueIds = [];
      this._data.firearmLinkToBeRemovedIds = [];
      this._data.firearmRemovedObjects = [];
      this._data.firearmCurrentLinkInitialized = false;
    }

    this._data.firearmCurrentLink = value || [];

    this._data.licenceId = uniqueId;
    this._data.firearmCurrentLinkInitialized = true;
  }

  setDeleteFromCurrentWeapon(value: string, uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      const data = this._data.firearmCurrentLink;

      const removedWeapon = data.find((item: any) => item.uniqueId === value);
      if (removedWeapon) {
        this._data.firearmRemovedObjects = [
          ...this._data.firearmRemovedObjects,
          removedWeapon,
        ];
      }

      this._data.firearmCurrentLink = data.filter((item: any) => item.uniqueId !== value);
      this._data.firearmToLinkIds = this._data.firearmToLinkIds.filter(
        (weapon: any) => weapon.uniqueId !== value,
      );
    }
  }

  getFormFirearmRemovedObjects(uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      return this._data.firearmRemovedObjects || [];
    }
    return [];
  }

  getFormFirearmCurrentLink(uniqueId: string) {
    const result = this._data.licenceId === uniqueId ? this._data.firearmCurrentLink : [];
    return result;
  }

  setFormWeapon(value: any, uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      const currentIds = this._data.firearmToLinkIds.map((item: any) => item.uniqueId);
      const newValues = value.filter((item: any) => !currentIds.includes(item.uniqueId));

      const weaponsToAdd: any[] = [];
      const reLinkedExistingWeapons: any[] = [];

      newValues.forEach((weapon: any) => {
        const wasRemoved = this._data.firearmRemovedObjects.find(
          (removed: any) =>
            removed.uniqueId === weapon.uniqueId ||
            (!!removed.firearmUniqueId && removed.firearmUniqueId === weapon.firearmUniqueId),
        );

        if (wasRemoved) {
          reLinkedExistingWeapons.push(wasRemoved);
        } else {
          weaponsToAdd.push(weapon);
        }
      });

      this._data.firearmToLinkIds = [...this._data.firearmToLinkIds, ...weaponsToAdd];
      this._data.firearmCurrentLink = [
        ...this._data.firearmCurrentLink,
        ...reLinkedExistingWeapons,
      ];

      this.cleanupRelinkedWeapons(reLinkedExistingWeapons);
    }
  }

  replaceFormWeapon(value: any, uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      const weaponsToAdd: any[] = [];
      const reLinkedExistingWeapons: any[] = [];

      value.forEach((weapon: any) => {
        const wasRemoved = this._data.firearmRemovedObjects.find(
          (removed: any) =>
            removed.uniqueId === weapon.uniqueId ||
            (!!removed.firearmUniqueId && removed.firearmUniqueId === weapon.firearmUniqueId),
        );

        if (wasRemoved) {
          reLinkedExistingWeapons.push(wasRemoved);
        } else {
          weaponsToAdd.push(weapon);
        }
      });

      this._data.firearmToLinkIds = weaponsToAdd;

      const reLinkedIds = reLinkedExistingWeapons.map((w: any) => w.uniqueId);
      this._data.firearmCurrentLink = this._data.firearmCurrentLink.filter(
        (existing: any) => !reLinkedIds.includes(existing.uniqueId),
      );
      this._data.firearmCurrentLink = [
        ...this._data.firearmCurrentLink,
        ...reLinkedExistingWeapons,
      ];

      this.cleanupRelinkedWeapons(reLinkedExistingWeapons);
    }
  }

  private cleanupRelinkedWeapons(weapons: any[]) {
    if (!weapons || weapons.length === 0) {
      return;
    }

    const relationIds = new Set<string>();
    const firearmIds = new Set<string>();

    weapons.forEach((weapon) => {
      if (weapon?.uniqueId) {
        relationIds.add(weapon.uniqueId);
      }
      if (weapon?.firearmUniqueId) {
        firearmIds.add(weapon.firearmUniqueId);
      }
    });

    if (relationIds.size === 0 && firearmIds.size === 0) {
      return;
    }

    this._data.firearmLinkToBeRemovedIds = this._data.firearmLinkToBeRemovedIds.filter(
      (itemId: string) => !relationIds.has(itemId) && !firearmIds.has(itemId),
    );

    this._data.firearmRemovedObjects = this._data.firearmRemovedObjects.filter(
      (item: any) =>
        !relationIds.has(item?.uniqueId ?? '') && !firearmIds.has(item?.firearmUniqueId ?? ''),
    );

    this._data.firearmRemovedIds = this._data.firearmRemovedIds.filter(
      (itemId: string) => !relationIds.has(itemId) && !firearmIds.has(itemId),
    );
  }

  getFormWeapon(uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      return this._data.firearmToLinkIds;
    }
    return [];
  }

  setFormFirearmLinkToBeRemovedIds(value: any, uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      this._data.firearmLinkToBeRemovedIds = value;
    }
  }

  getFormFirearmLinkToBeRemovedIds(uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      return this._data.firearmLinkToBeRemovedIds;
    }
    return [];
  }

  setFirearmRemovedIds(value: string, uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      if (!this._data.firearmRemovedIds.includes(value)) {
        this._data.firearmRemovedIds = [...this._data.firearmRemovedIds, value];
      }
    }
  }

  getFirearmRemovedIds(uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      return this._data.firearmRemovedIds;
    }
    return [];
  }

  getSelectedPrice() {
    return this._data.selectedPrice;
  }

  setSelectedPrice(value: string) {
    this._data.selectedPrice = value;
  }

  setLicenceId(value: string) {
    if (this._data.licenceId !== value) {
      this._data.formData = {};
      this._data.firearmToLinkIds = [];
      this._data.firearmLinkToBeRemovedIds = [];
      this._data.firearmCurrentLink = [];
      this._data.firearmRemovedObjects = [];
      this._data.firearmRemovedIds = [];
      this._data.safeStorages = [];
      this._data.licenceAttachmentsData = [];
      this._data.licenceAttachmentsToDeleteIds = [];
      this._data.photoFile = null;
      this._data.image = null;
      this._data.selectedPrice = null;
      this._data.firearmCurrentLinkInitialized = false;
    }
    this._data.licenceId = value;
  }

  clearStore() {
    const emptyState = {
      licenceId: null,
      selectedPrice: null,
      formData: {},
      firearmToLinkIds: [],
      firearmLinkToBeRemovedIds: [],
      firearmCurrentLink: [],
      firearmRemovedObjects: [],
      safeStorages: [],
      licenceAttachmentsData: [],
      licenceAttachmentsToDeleteIds: [],
      photoFile: null,
      image: null,
      firearmRemovedIds: [],
      firearmCurrentLinkInitialized: false,
    };

    Object.keys(this._data).forEach((key) => {
      if (!(key in emptyState)) {
        delete (this._data as any)[key];
      }
    });

    Object.assign(this._data, emptyState);
  }

  prepareForNewOperation(licenceId: string | null | undefined) {
    if (!licenceId) {
      return;
    }

    if (this._data.licenceId !== licenceId) {
      this._data.formData = {};
      this._data.firearmToLinkIds = [];
      this._data.firearmLinkToBeRemovedIds = [];
      this._data.firearmRemovedIds = [];
      this._data.firearmRemovedObjects = [];
      this._data.safeStorages = [];
      this._data.licenceAttachmentsData = [];
      this._data.licenceAttachmentsToDeleteIds = [];
      this._data.photoFile = null;
      this._data.image = null;
      this._data.selectedPrice = null;
      this._data.firearmCurrentLinkInitialized = false;
    }

    this._data.licenceId = licenceId;
  }

  hasInitializedFirearmCurrentLink(uniqueId: string) {
    if (this._data.licenceId === uniqueId) {
      return Boolean(this._data.firearmCurrentLinkInitialized);
    }
    return false;
  }
}

const instance = new LicenceStore();
Object.freeze(instance);

export default instance;
